import { useState } from "react";
import "../../../css/bootstrap5.css";
import "./Textarea.css";

const Textarea = ({
  margin,
  className,
  bgcolor,
  bcolor,
  text,
  placeholder,
  textcolor,
  value,
  onChange,
  style,
  rows = 4, // تعداد سطرها پیش‌فرض
  textAlign = "left",
  disabled,
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <div className={`m-${margin} ${className}`}>
      <label
        className={`labelpass ${focused || value ? "floating" : ""} text-${
          disabled ? "secondary" : bcolor
        }`}
        style={{
          "--bg": `${bg(bgcolor)}`,
          "--scolor": `--bs-${bcolor}-rgb`,
        }}
        aria-label={text}
      >
        <textarea
          className={`inputpass border-${
            disabled ? "secondary" : bcolor
          } text-${textcolor}`}
          name={text}
          placeholder={text}
          style={{ textAlign, height: "auto", ...style }}
          rows={rows}
          required
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e) => onChange(e.target.value)}
          value={value}
          disabled={disabled}
        />
      </label>
    </div>
  );
};

const bg = (color) => {
  switch (color) {
    case "dark":
      return "#212529";
    case "white":
      return "#ffffff";
    default:
      return "#ffffff";
  }
};

export default Textarea;
